module.exports = __webpack_public_path__ + "img/laugh_ios_802.png";